module.exports = __webpack_public_path__ + "static/media/bgShapA.029ec50d.png";